import { createFishEntryDrawer } from '../fishEntry/entryDrawer';

// /kontakt — a fish that took, followed, was lost or was missed but never
// landed. All behaviour lives in the shared factory (see fishEntry/entryDrawer.js);
// this file only supplies the contact-specific keys. `entryName` is
// simultaneously the fields.get() key, the FormFieldsCompact objectName, the
// incoming prop name (props.fishContact) and the state key (state.fishContact).
export default createFishEntryDrawer({
    entryName: 'fishContact',
    dateField: 'contactDate',
    testIdPrefix: 'fishcontact',
    titleId: 'fishContact.title',
    titleDefault: 'Register contact',
});
